/** Plain numeric string for API / server (e.g. "10000", "10000.5", ""). */

/**
 * @param {unknown} v
 * @returns {string}
 */
export function moneyPropToString(v) {
  if (v === null || v === undefined || v === "") return ""
  return String(v)
}

/**
 * Parse raw input (possibly with $, commas) into a canonical money string.
 *
 * @param {string} raw
 * @returns {string | undefined} canonical, or undefined if the edit should be ignored
 */
export function parseUsdInputRaw(raw) {
  const cleaned = raw.replace(/[$,\s]/g, "")
  if (cleaned === "") return ""
  if (cleaned === ".") return "."
  if (!/^\d*\.?\d{0,2}$/.test(cleaned)) return undefined
  return cleaned
}

/**
 * Format canonical money string as USD for display while typing.
 *
 * @param {string | number | null | undefined} canonical
 * @returns {string}
 */
export function formatUsdCanonical(canonical) {
  if (canonical === "" || canonical === null || canonical === undefined) return ""
  const s = String(canonical)
  if (s === ".") return "$."

  const trailingDot = s.endsWith(".") && s.split(".").length === 2 && s.slice(0, -1).match(/^\d*$/)
  const core = trailingDot ? s.slice(0, -1) : s
  const parts = core.split(".")
  let intRaw = parts[0]
  const decRaw = parts.length > 1 ? parts[1] : null

  if (intRaw === "" || intRaw === undefined) intRaw = "0"
  const intNum = parseInt(intRaw, 10)
  const intFmt = Number.isNaN(intNum) ? "0" : intNum.toLocaleString("en-US")

  if (decRaw !== null && decRaw !== "") return `$${intFmt}.${decRaw}`
  if (trailingDot) return `$${intFmt}.`
  return `$${intFmt}`
}

/**
 * Normalize before submit / on blur (trim trailing ".", drop empty / lone ".").
 *
 * @param {string | null | undefined} canonical
 * @returns {string}
 */
export function normalizeMoneyCanonical(canonical) {
  if (canonical === "" || canonical === null || canonical === undefined) return ""
  let t = String(canonical)
  if (t === ".") return ""
  if (t.endsWith(".")) t = t.slice(0, -1)
  if (t === "") return ""
  const n = Number(t)
  if (Number.isNaN(n)) return ""
  return String(n)
}
